export default __webpack_public_path__ + "static/media/Orca.8f858b1b.jpeg";